import { xhr } from '@/xhr/endpoints';

//
// state
const state = {
  organizationDetailsCache: {},
};

//
// getters
const getters = {
  organizationID: state => Object.keys(state.organizationDetailsCache)[0],
};

//
// mutations
const mutations = {
  cacheOrganizationDetails(state, organizationDetails) {
    state.organizationDetailsCache = {
      ...state.organizationDetailsCache,
      [organizationDetails._id]: organizationDetails,
    };
  },
};

//
// actions
const actions = {
  getUserOrganizations: async ({ page, resultsPerPage, sortColumn, sortDirection, filters }) => {
    let organizations = await xhr.getUserOrganizations(
      page,
      resultsPerPage,
      sortColumn,
      sortDirection,
      filters
    );
    return organizations;
  },
  loadOrganizationDetails: async ({ commit }, id) => {
    try {
      let organizationDetails = await xhr.getOrganizationDetails(id);
      commit('cacheOrganizationDetails', organizationDetails);
    } catch (err) {
      console.error(err);
    }
  },
  getOrganizationTeamDetails: async ({ getters }, id) => {
    try {
      let organizationDetails = await xhr.getOrganizationTeamDetails(getters.organizationID, id);
      return organizationDetails;
    } catch (err) {
      console.error(err);
    }
  },
  loadOrganizationMembers: async (
    { getters },
    { page, resultsPerPage, sortColumn, sortDirection, filters }
  ) => {
    try {
      let organizationMembers = await xhr.getOrganizationMembers(
        getters.organizationID,
        page,
        resultsPerPage,
        sortColumn,
        sortDirection,
        filters
      );
      return organizationMembers;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  loadAllCurrentOrganizationMembers: async ({ getters }) => {
    try {
      let organizationMembers = await xhr.getAllOrganizationMembers(getters.organizationID);
      return organizationMembers;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  loadOrganizationTeams: async (
    { getters },
    { page, resultsPerPage, sortColumn, sortDirection, filters }
  ) => {
    try {
      let organizationTeams = await xhr.getOrganizationTeams(
        getters.organizationID,
        page,
        resultsPerPage,
        sortColumn,
        sortDirection,
        filters
      );
      return organizationTeams;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  loadAllCurrentOrganizationTeams: async ({ getters }) => {
    try {
      let organizationTeams = await xhr.getAllOrganizationTeams(getters.organizationID);
      return organizationTeams;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
